import AssessmentDetail from "pages/Courses/AssessmentDetails";
import CourseDetail from "pages/Courses/CourseDetail";
import ChannelPartnerDashboard from "pages/Dashboards/ChannelPartnerDashboard";
import ChannelPartnerProfile from "pages/Profile/ChannelPartnerProfile";
import TraineeListing from "pages/Trainee/TraineeListing";
import CoursePurchase from "pages/Courses/CoursePurchase";
import AddTrainee from "pages/Trainee/AddTrainee";
import CsvTraineeImport from "pages/CsvImport/CsvTraineeImport";
import Questions from "pages/QuestionBank/Questions";
import TraineeDetails from "pages/Trainee/TraineeDetails";
import Assessment from "pages/Assessment/Assessment";
import ChannelPartnerCourses from "pages/Courses/ChannelPartner/ChannelPartnerCourses";
import ChannelPartnerCourseDetails from "pages/Courses/ChannelPartner/ChannelPartnerCourseDetails";
import EnrollPage from "pages/Courses/ChannelPartner/EnrollPage";
import ChannelPartnerEnrolledCourseDetails from "pages/ChannelPartner/ChannelPartnerEnrolledCourseDetails";
import ChannelPartnerMyCourses from "pages/ChannelPartner/ChannelPartnerMyCourses";
import OfflineAttendance from "pages/AttendanceModule/ChannelPartnerLogin/OfflineAttendance";
import DocumentsApproval from "pages/DocumentApproval/DocumentsApproval";
import ApprovalCourses from "pages/Courses/ChannelPartner/ApprovalCourses";
import ChannelPartnerCourseEnrollmentReport from "pages/Reports/ChannelPartnerCourseEnrollmentReport";

const routes = [
  {
    show: true,
    path: "/dashboard",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-deep-blue",
    component: <ChannelPartnerDashboard />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  {
    show: false,
    path: "/profile",
    name: "Channel Partner Profile",
    icon: "ni ni-shop text-deep-blue",
    component: <ChannelPartnerProfile />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  // My Courses list
  {
    show: true,
    path: "/my-courses",
    name: "My Courses",
    icon: "ni ni-hat-3 text-deep-blue",
    component: <ChannelPartnerMyCourses />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  // My Course Details (all tabs)
  {
    show: false,
    path: "/my-courses/:id/details",
    name: "My Course Detail",
    icon: "ni ni-shop text-deep-blue",
    component: <ChannelPartnerEnrolledCourseDetails />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  // Courses list
  {
    show: true,
    path: "/course",
    name: "Courses",
    icon: "ni ni-hat-3 text-deep-blue",
    component: <ChannelPartnerCourses />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  {
    show: true,
    path: "/document-approval",
    name: "Documents Approval",
    icon: "ni ni-paper-diploma text-deep-blue",
    component: <DocumentsApproval />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
   {
    show: true,
    path: "/approval-courses",
    name: "Payments",
    icon: "ni ni-credit-card text-deep-blue",
    component: <ApprovalCourses />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  {
      show: true,
      path: "/attendance",
      name: "Attendance",
      icon: "ni ni-book-bookmark text-deep-blue",
      component: <OfflineAttendance />,
      layout: "/channel-partner",
      roles: ["CHANNEL_PARTNER"],
    },
  // Course Details (only 2 tabs)
  {
    show: false,
    path: "/course/:id/details",
    name: "Course Detail",
    icon: "ni ni-shop text-deep-blue",
    component: <ChannelPartnerCourseDetails />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  {
    show: false,
    path: "/course/:id",
    name: "Web Courses enroll",
    icon: "ni ni-ungroup text-primary",
    component: <EnrollPage />,
    layout: "/channel-partner",
  },
  {
    show: false,
    path: "/course/:id/purchase",
    name: "Course Purchase",
    icon: "ni ni-shop text-deep-blue",
    component: <CoursePurchase />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  {
    show: false,
    path: "/course/:id/details",
    name: "Course Detail",
    icon: "ni ni-shop text-deep-blue",
    component: <CourseDetail />,
    layout: "/channel-partner",
    roles: ["TRAINER"],
  },
  {
    show: false,
    path: "/course/:id/details/:assessmentId",
    name: "Assessment Detail",
    icon: "ni ni-shop text-deep-blue",
    component: <AssessmentDetail />,
    layout: "/channel-partner",
    roles: ["TRAINER"],
  },
  {
    show: true,
    path: "/trainee",
    name: "Trainees",
    icon: "fa-solid fa-user-graduate pr-3 text-deep-blue",
    component: <TraineeListing />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  {
    show: false,
    path: "/trainee/:id/details",
    name: "Trainee Detail",
    icon: "ni ni-shop text-deep-blue",
    component: <TraineeDetails />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  {
    show: false,
    path: "/trainee/add-trainee",
    name: "Add-Trainee",
    icon: "ni ni-single-02 text-deep-blue",
    component: <AddTrainee />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  {
    show: false,
    path: "/trainee/edit/:id",
    name: "Add-Trainee",
    icon: "ni ni-single-02 text-deep-blue",
    component: <AddTrainee />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  {
    show: false,
    path: "/trainee/:id/details",
    name: "Trainee Details",
    icon: "ni ni-single-02 text-deep-blue",
    component: <TraineeDetails />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  {
    show: false,
    path: "/course/:id/purchase/add-trainee",
    name: "Add Trainee",
    icon: "ni ni-shop text-deep-blue",
    component: <AddTrainee />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  {
    show: false,
    path: "/course/:id/purchase/import-trainee",
    name: "Add Trainee",
    icon: "ni ni-shop text-deep-blue",
    component: <CsvTraineeImport />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  {
    show: false,
    path: "/question-bank/add/questions",
    name: "Question Bank",
    icon: "ni ni-collection text-deep-blue",
    component: <Questions />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  {
    show: true,
    path: "/assessment",
    name: "Assessments",
    icon: "ni ni-paper-diploma text-deep-blue",
    component: <Assessment />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  {
    show: false,
    path: "/assessment/:id/details",
    name: "assessment Detail",
    icon: "ni ni-shop text-deep-blue",
    component: <AssessmentDetail />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  {
    show: true,
    collapse: true,
    name: "Reports",
    icon: "ni ni-chart-bar-32 text-deep-blue",
    state: "reportsCollapse",
    roles: ["CHANNEL_PARTNER"],
    views: [
      {
        show: true,
        path: "/reports/course-enrollment",
        name: "Course Enrollment Report",
        miniName: "CE",
        component: <ChannelPartnerCourseEnrollmentReport />,
        layout: "/channel-partner",
        roles: ["CHANNEL_PARTNER"],
      },
    ],
  },
];

export default routes;
